import { parseHref } from '@/shared/utils/href';
import { isJuniorEnvironment } from '@/shared/config/junior';

import type { JuniorEnvironment } from '@/shared/config/junior';
import type { Href } from '@/shared/utils/href';

type DecodedGameConfig =
	| { data_href: Href; env?: JuniorEnvironment; exit_url?: string; error?: never }
	| { data_href?: never; env?: never; exit_url?: never; error: string };

export const decodeGameConfig = (encoded: string | null): DecodedGameConfig => {
	if (encoded === null) return { error: 'Junior mode requires the config query parameter' };

	try {
		const base64 = encoded.replace(/ /g, '+').replace(/-/g, '+').replace(/_/g, '/');
		const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
		const decoded = new TextDecoder('utf-8', { fatal: true }).decode(
			Uint8Array.from(atob(paddedBase64), (character) => character.charCodeAt(0)),
		);
		// Some launchers send object-style keys instead of strict JSON.
		const normalized = decoded.replace(
			/"(?:[^"\\]|\\.)*"|([{,]\s*)(href|method|env|exit_url)\s*:/g,
			(match, prefix, key) => (prefix ? `${prefix}"${key}":` : match),
		);
		const value = JSON.parse(normalized);
		const dataHref = parseHref(value?.data_href);
		if (value.env !== undefined && !isJuniorEnvironment(value.env)) {
			return { error: 'Invalid Junior env: expected nl_develop, nl_staging, or nl_master' };
		}
		if (value.exit_url !== undefined && typeof value.exit_url !== 'string') {
			return { error: 'Invalid Junior exit_url: expected a string' };
		}
		return { data_href: dataHref, env: value.env, exit_url: value.exit_url };
	} catch {
		return { error: 'Invalid base64 game config: expected data_href with a href and supported method' };
	}
};
